import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  CircularProgress,
  Box,
} from "@mui/material";
import { updateOrderCustomer } from "../../../../../services/Admin/OrdersApi";

const EditeOrderCustomer = ({ open, onClose, order, onUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    address2: "",
    address3: "",
    phone2: "",
    phone3: "",
  });

 useEffect(() => {
  if (open && order) {
    const c = order.customer || {};

    setFormData({
      name: c.name || order.customer_name || "",
      phone: c.phone || order.customer_phone || "",
      email: c.email || "",
      address: c.address || order.customer_address || "",
      address2: c.address2 || order.customer_address2 || "",
      address3: c.address3 || order.customer_address3 || "",
      phone2: c.phone2 || order.customer_phone2 || "",
      phone3: c.phone3 || order.customer_phone3 || "",
    });

    setError("");
    setSuccess(false);
  }
}, [open, order]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setError("الاسم مطلوب");
      return false;
    }
    if (!formData.phone.trim()) {
      setError("رقم الهاتف مطلوب");
      return false;
    }

    const phoneRegex = /^[0-9]{10,}$/;
    if (!phoneRegex.test(formData.phone.replace(/[^0-9]/g, ""))) {
      setError("رقم الهاتف غير صحيح");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await updateOrderCustomer({
        customerId: order.customer_id || order.customer?.id,
        name: formData.name,
        phone: formData.phone,
        email: formData.email || null,
        address: formData.address || null,
        address2: formData.address2 || null,
        address3: formData.address3 || null,
        phone2: formData.phone2 || null,
        phone3: formData.phone3 || null,
      });

      setSuccess(true);

      // ✅ ابعت القيم الجديدة للأب عشان يحدّث الـ UI فورًا
      onUpdated?.({
        customerId: order.customer_id || order.customer?.id,
        customer: {
          name: formData.name,
          phone: formData.phone,
          email: formData.email || null,
          address: formData.address || null,
          address2: formData.address2 || null,
          address3: formData.address3 || null,
          phone2: formData.phone2 || null,
          phone3: formData.phone3 || null,
        },
      });

      // ✅ اقفل فورًا (أو تقدر تسيبها 300ms لو عايز تظهر success)
      onClose?.();
    } catch (err) {
      console.error("خطأ في تحديث بيانات العميل:", err);
      setError(err.message || "حدث خطأ في تحديث البيانات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle sx={{ fontWeight: "bold", textAlign: "right" }}>
        تعديل بيانات العميل
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            تم تحديث البيانات بنجاح
          </Alert>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="الاسم"
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="رقم الهاتف"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            fullWidth
            required
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="البريد الإلكتروني"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="العنوان"
            name="address"
            value={formData.address}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
            multiline
            rows={2}
          />

          <TextField
            label="العنوان (إضافي 1)"
            name="address2"
            value={formData.address2}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="العنوان (إضافي 2)"
            name="address3"
            value={formData.address3}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="رقم الهاتف (إضافي 1)"
            name="phone2"
            value={formData.phone2}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
          />

          <TextField
            label="رقم الهاتف (إضافي 2)"
            name="phone3"
            value={formData.phone3}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            dir="rtl"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined">
          إلغاء
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          {loading && <CircularProgress size={20} color="inherit" />}
          {loading ? "جاري الحفظ..." : "حفظ التعديلات"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditeOrderCustomer;